import { useEffect, useState } from "react";
import { APP_ENVS, ENVConfig, ENVIRONMENT_CONFIGURATION } from "../constants";

export type EnvironmentContextType = {
  env?: ENVConfig;
};

type UseEnvironmentProps = {
  envType: (typeof APP_ENVS)[number];
};

export default function useEnvironment({ envType }: UseEnvironmentProps) {
  const [env, setEnv] = useState<ENVConfig>();
  useEffect(() => {
    setEnv(ENVIRONMENT_CONFIGURATION[envType] ?? undefined);
  }, [envType]);

  return {
    env,
  };
}
